class PriceService {
    constructor() {
        this.baseURL = process.env.REACT_APP_WC_SITE_URL;
    }

    async getLetterPrice({ text, fontSizeErpId, fontErpId, typeErpId }, signal) {
        const response = await fetch(
            `${this.baseURL}/wp-json/rodlew_app/v1/letter-price`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ text, fontSizeErpId, fontErpId, typeErpId }),
                signal,
            }
        );
        return await response.json();
    }
}

const priceService = new PriceService();
export default priceService;
